jQuery(document).ready(function () {
	jQuery(".caramella__block--postloop-container").each(function () {
		let loadcontainer = jQuery(this);
		let loadbutton = jQuery('.' + jQuery(this).data("button"));
		loadbutton.addClass('disabled');
		loadcontainer.find('.loading').hide();
		loadcontainer.on('queryloop_loadmore', function () {
			queryloop_loadmore({container: loadcontainer, data: loadcontainer.data(), button: loadbutton});
		});
		loadbutton.on('click', function (event) {
			event.preventDefault();
			loadcontainer.data('reset', "0");
			loadcontainer.trigger('queryloop_loadmore');
		});
		loadcontainer.trigger('queryloop_loadmore');
	});

	jQuery('.targeted-loadmorebutton').on('click', function (event) {
		event.preventDefault();
		if(!jQuery(this).hasClass('disabled')) {
			jQuery(jQuery(this).data("target")).data('reset', "0");
			jQuery(jQuery(this).data("target")).trigger('queryloop_loadmore');
		}
	});

});

function queryloop_loadmore(event) {
	if (event.data.paged > event.data.max) {
		return false;
	}
	let postsLoaded = new CustomEvent('postsUpdated', {detail: {type: 'postloop'}});
	jQuery.ajax({
		url: caramella.ajax_url,
		data: {
			'action': 'load_posts',
			'rawData': event.data
		},
		type: 'POST',
		beforeSend: function () {
			event.container.children('.loading').show().fadeTo('fast', .9);
			event.button.addClass('disabled');
		},
		success: function (data) {
			if (data) {
				if (data.html) {
					event.container.find('.queryloop-preloder').hide();
					if (event.data.reset === "1") {
						event.container.hide().html(data.html).fadeIn('slow');
					} else {
						jQuery(data.html).hide().appendTo(event.container).fadeIn('slow');
					}
					event.container.data('max', data.max_num_pages);
					event.container.children('.loading').fadeTo('slow', 0).hide();
					if (event.data.paged >= event.data.max) {
						event.button.fadeOut('slow');
					} else if (!event.button.is(":visible")) {
						event.button.fadeIn('slow');
					}
					event.data.paged++;
					event.container.data('paged', event.data.paged);
				}
			}
			event.button.removeClass('disabled');
			document.dispatchEvent(postsLoaded);
		},
		error: function (error) {
			console.log('Ajax error on queryloop: ', error);
			event.button.removeClass('disabled');
		}
	});
}

